<template>
  <div>
    <PvDataTable :value="transactions"
                 size="small" 
                 :paginator="showPagination" 
                 :rows=10
                 :statekey="BASE_STORAGE_KEY + '-hcehometransactions'"
                 :stateStorage="'session'" >
      <PvColumn v-for="col of columns" 
                :key="col.field" 
                :field="col.field"
                :header="col.header"
                :class="col.bodySlot === 'action' ? 'action-column' : undefined"
                :style="{ width: col.width || 'auto' }">                
        <template v-if="col.bodySlot === 'actions'" #body="slotProps">
          <PvButton @click="viewTransaction(slotProps.data.transactionId)"
                    size="small"
                    severity="primary"
                    :title="buttonProperties.title"
                    :aria-label="buttonProperties.aria + slotProps.data.transactionTitle + '.'"
                    class="action-btn"
                    :icon="buttonProperties.icon"
                    rounded outlined />    
        </template>
        <template v-else-if="col.bodySlot === 'date'" #body="slotProps">
          {{ formatDate(slotProps.data[col.field]) }}
        </template>
      </PvColumn>
      <template #empty>
        <NoData message="No transactions to display." />
      </template>      
    </PvDataTable>                
  </div>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { onMounted, ref, watch, computed } from 'vue';
import { useRouter } from 'vue-router';

// Components
import NoData from '../common/NoData.vue';

// Composables


// Stores


// Constants and Utils
import { ICONS, BASE_STORAGE_KEY } from '@/utils/constants';
import { formatDate } from '@/utils/dataUtils';
import { HCE_ROUTES } from '@/router/routeConstants';


// ===============================
// PROPS & EMITS
// ===============================
const props = defineProps({
  transactions: {
    type: Array,
    default: null,
    required: true
  },
  isTransactionsCompleted: {
    type: Boolean,
    default: false,
    required: false
  }
});

// ===============================
// COMPOSABLES & STORES
// ===============================
const router = useRouter();

// ===============================
// REACTIVE STATE
// ===============================
const showPagination = ref(false);

// ===============================
// CONSTANTS
// ===============================
const columns = [
  { header: 'Actions', bodySlot: 'actions', width: '100px' },
  { field: 'transactionTitle', header: 'Transaction Title' },
  { field: 'transactionTypeDescription', header: 'Transaction Type' },
  { field: 'proposedCompletionDate', header: 'Proposed Completion Date', bodySlot: 'date', width: '150px' },
  { field: 'dueDate', header: 'Due Date', bodySlot: 'date', width: '150px' },
  { field: 'transactionStatusDescription', header: 'Status' }
];

// ===============================
// COMPUTED PROPERTIES
// ===============================
const buttonProperties = computed (() => {
  return {
    title: props.isTransactionsCompleted ? 'View the transaction details.' : 'Edit the transaction details.',
    aria: props.isTransactionsCompleted ? 'View details for transaction ' : 'Edit details for transaction ',
    icon: props.isTransactionsCompleted ? ICONS.View :ICONS.Edit,
  };
});

// ===============================
// METHODS
// ===============================
const viewTransaction = (transactionId) => {
  if (transactionId) {
    router.push({ name: HCE_ROUTES.EDIT_TRANSACTION.name, params: { id: transactionId } });
  } 
};

const updatePagination = () => {
  if (props.transactions && props.transactions.length > 10) {
    showPagination.value = true;
  } else {
    showPagination.value = false;
  }
};

// ===============================
// WATCHERS
// ===============================
watch(() => props.transactions, () => {
  updatePagination();
});

// ===============================
// LIFECYCLE HOOKS
// ===============================
onMounted(() => {
  updatePagination();
});


// ===============================
// EXPOSE
// ===============================

</script>